<div class="modal fade show" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"><i class="fa fa-exclamation-triangle text-danger mx-5" aria-hidden="true"></i>{{title}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="cancel()" data-testid="guard-confirm-close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body px-5">{{message}}</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()" data-testid="guard-confirm-cancel">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirm()" data-testid="guard-confirm-confirm">Confirm</button>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/guard/guard-confirm/guard-confirm.component.html